import { render, staticRenderFns } from "./AddAwardee.vue?vue&type=template&id=2c4030df&"
import script from "./AddAwardee.vue?vue&type=script&lang=js&"
export * from "./AddAwardee.vue?vue&type=script&lang=js&"
import style0 from "./AddAwardee.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "AddAwardee.vue"
export default component.exports